import { Box, Grid, Paper as MuiPaper } from "@mui/material";
import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import Typography from "component/MarketPlace/Typography";
import { Button } from "component/MarketPlace/ButtonComponents";
import imgChat1 from "../../../assets/images/chat1.png";
import imgChat2 from "../../../assets/images/chat2.png";
import imgChat3 from "../../../assets/images/chat3.png";

export interface IDigitalAssistantCardProps {
  locale?: any;
  handleOpenChat: () => void;
  handleDismissDigitalAssistantCard: () => void;
  verbiageConfig?: string;
  isGlobalSearch?: boolean;
  keyword?: string;
  isGlobalSearchEnabled?: boolean;
}

const DigitalAssistantCard = (props: IDigitalAssistantCardProps) => {
  const { locale, handleOpenChat, handleDismissDigitalAssistantCard, verbiageConfig, isGlobalSearch, keyword, isGlobalSearchEnabled } = props;
  const theme = useContext(ThemeContext);
  const description  = verbiageConfig?.replace("{{keyword}}", keyword as string);
  const knowledgeDescription = isGlobalSearchEnabled ? locale?.digitalAssistant?.description : description;

  return (
    <Box
      width="100%"
      mb={{ xs: `${theme.uptimeSpace[16]}px`, sm: '50px' }}
      maxHeight={{ xs:'unset', sm:'223px' }}
      position='relative'
    >
      <MuiPaper
        elevation={0}
        sx={{
          width: "100%",
          padding: { xs: `${theme.uptimeSpace[10]}px`, md: `${theme.uptimeSpace[10]}px ${theme.uptimeSpace[15]}px`},
          backgroundColor: "#ECEEF1",
          borderRadius: "16px",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={6}
            display="flex"
            justifyContent="start"
            flexDirection="column"
            gap="10px"
          >
            <Typography
              margin="5px 0"
              variant="h4"
              color={theme.uptimeColors.mainTheme.primary}
              fontSize={{ xs: `${theme.uptimeFontSizes.desktop.fz6}px`, md: `${theme.uptimeFontSizes.desktop.fz9}px` }}
              lineHeight= {{ xs: `${theme.uptimeLineHeights.mobile.lh4}px`, md: `${theme.uptimeLineHeights.desktop.lh9}px` }}
              id="lbl-digitalassistantcard-label"
            >
              {locale?.digitalAssistant?.uptimeVirtualAssistant}
            </Typography>
            <Typography
              maxWidth="350px"
              fontSize="12px"
              fontWeight="400"
              color="text.primary"
              id="lbl-digitalassistantcard-description"
            >
              {isGlobalSearch ? description : knowledgeDescription}
             </Typography>
            <Button
              sx={{
                height: { xs: "auto", md: "34px" } ,
                width: { xs: "120px", md: "144px" },
                marginTop: { xs: "5px", md: "10px" },
                minHeight: "unset !important",
                paddingY: { xs: "3px", md: "6px" },
                fontSize: { xs: "12px", md: "14px" }
              }}
              color="primary"
              variant="contained"
              onClick={handleOpenChat}
              id="btn-digitalassistantcard-getstarted"
            >
              {locale?.digitalAssistant?.btnGetStarted}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} display="flex" justifyContent="center">
            <Box>
              <img width="109px" height="176px" alt="chat" src={imgChat1} title="Chat" />
            </Box>
            <Box
              margin={`${theme.uptimeSpace[12]}px 0 0 -${theme.uptimeSpace[12]}px`}
            >
              <img width="107px" height="172px" alt="chat" src={imgChat2} title="Chat" />
            </Box>
            <Box margin={`48px 0 0 -${theme.uptimeSpace[12]}px`}>
              <img width="100px" height="161px" alt="chat" src={imgChat3} title="Chat" />
            </Box>
            <Button
              onClick={handleDismissDigitalAssistantCard}
              variant="text"
              color="primary"
              sx={{ 
                width: "55px",
                height: "24px",
                fontSize: {xs: '12px', md: '14px'},
                top: {xs: '0', sm: '10px'},
                right: {xs: '10px', md: '20px'},
                position: 'absolute'
              }}
              id="btn-digitalassistantcard-dismiss"
            >
              {locale?.digitalAssistant?.btnDismiss}
            </Button>
          </Grid>
        </Grid>
      </MuiPaper>
    </Box>
  );
};

export const defaultProps: IDigitalAssistantCardProps = {
  locale: {
    digitalAssistant: {
      uptimeVirtualAssistant: "UPtime Virtual Assistant",
      description:
        "Need IT help? We offer a support system for troubleshooting, knowledge search, ticket creation, and live support. Our aim is to help you find a solution to get back to work and achieve your goals.",
      btnGetStarted: "Get Started",
      btnDismiss: "Dismiss"
    },
  },
  handleOpenChat: () => {},
  handleDismissDigitalAssistantCard: () => {},
};
DigitalAssistantCard.defaultProps = defaultProps;

export default DigitalAssistantCard;
